class RecipeDetailVideoController {

    constructor($sce) {
        this.$sce = $sce;
    }

    $onInit() {
        this.trustedUrl = this.$sce.trustAsResourceUrl(`${this.url}${this.url.indexOf('?') === -1 ? '?' : '&'}showinfo=0&enablejsapi=1`);
    }

}

const recipeDetailVideoComponentDefinition = {
    bindings: {
        url: '=',
    },
    controller: ['$sce', RecipeDetailVideoController],
    template: require('./recipe-detail-video.component.html').trim(),
};

module.exports = {
    RecipeDetailVideoController,
    recipeDetailVideoComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipedetail/recipe-detail-video.component.js